export default __webpack_public_path__ + "static/media/trapezoid.58dcb0c6.webp";